<template>
  <div class="general-quotation-info" v-if="quotationData">
    <div class="border rounded p-3">
      <div v-if="quotationData.import_export_type" class="mb-3">
        <strong>Тип операции:</strong>
        <p class="mb-0">
          <span class="badge badge-primary">
            {{ quotationData.import_export_type === 'import' ? 'Импорт' : 'Экспорт' }}
          </span>
        </p>
      </div>

      <div v-if="quotationData.service_description" class="mb-3">
        <strong>Описание услуги:</strong>
        <p class="mb-0">{{ quotationData.service_description }}</p>
      </div>

      <div v-if="quotationData.deadline_start" class="mb-3">
        <strong>Ориентировочная дата таможенного оформления:</strong>
        <p class="mb-0">{{ formatDate(quotationData.deadline_start) }}</p>
      </div>

      <div v-if="quotationData.delivery_frequency" class="mb-3">
        <strong>Периодичность поставок:</strong>
        <p class="mb-0">{{ quotationData.delivery_frequency }}</p>
      </div>

      <div v-if="quotationData.additional_requirements" class="mb-3">
        <strong>Дополнительные требования:</strong>
        <p class="mb-0">{{ quotationData.additional_requirements }}</p>
      </div>

      <div v-if="quotationData.budget_amount" class="mb-0">
        <strong>Бюджет:</strong>
        <p class="mb-0">{{ formatCurrency(quotationData.budget_amount, quotationData.budget_currency || 'RUB') }}</p>
      </div>
    </div>

    <OrderServiceGeneralQuotationAnswerForms
      v-if="shouldShowAnswers && !isClient"
      class="mt-4"
      :order-id="quotation.order_id"
      :order-service-id="quotation.order_service_id"
      :order-service-quotation-id="quotation.id"
      :order-reference-status-id="quotation.order_reference_status_id || null"
      :show-data-only="true"
      @orderUpdated="$emit('orderUpdated', $event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import OrderServiceGeneralQuotationAnswerForms from '@/components/orders/orderServiceQuotation/OrderServiceGeneralQuotationAnswerForms.vue';

export default {
  name: 'OrderServiceGeneralQuotationInfo',
  components: {
    OrderServiceGeneralQuotationAnswerForms
  },
  props: {
    quotation: { type: Object, required: true },
    showAnswers: { type: Boolean, default: false }
  },
  computed: {
    ...mapGetters('auth', ['currentUser']),
    isClient() {
      return this.currentUser && this.currentUser.role
        ? this.currentUser.role.includes('client')
        : false;
    },
    quotationData() {
      if (!this.quotation) return null;
      return this.quotation.data || this.quotation;
    },
    shouldShowAnswers() {
      return Boolean(
        this.showAnswers &&
        this.quotation &&
        this.quotation.id &&
        this.quotation.order_id &&
        this.quotation.order_service_id
      );
    }
  },
  methods: {
    formatDate(value) {
      if (!value) return '';
      return new Date(value).toLocaleDateString('ru-RU');
    },
    formatCurrency(amount, currency = 'RUB') {
      if (amount === null || amount === undefined || amount === '') {
        return `0 ${currency}`;
      }
      const number = Number(amount);
      if (Number.isNaN(number)) {
        return `${amount} ${currency}`;
      }
      return `${number.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} ${currency}`;
    }
  }
};
</script>

<style scoped>
.general-quotation-info {
  line-height: 1.4;
}

.general-quotation-info strong {
  text-transform: none;
}
</style>

